import {Component, ViewChild} from '@angular/core';
import {AgGridAngular} from "ag-grid-angular";
import {ColDef, GridReadyEvent} from "ag-grid-community";
import {Observable} from "rxjs";
import {MatDialog} from "@angular/material/dialog";
import {CustomerDialogComponent} from "./customer-dialog/customer-dialog.component";
import {CustomerService} from "../services/customer.service";
import {BtnCellRendererComponent} from "../shared/table/button-cell-renderer.component";
import {HubspotService} from "../services/hubspot.service";

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent {

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  public columnDefs: ColDef[] = [
    { field: 'id', width: 50, minWidth: 50, maxWidth: 50 },
    { field: 'name', editable: true },
    { field: 'hubspotToken', editable: true },
    { field: 'apiKey' },
    { field: 'active', width: 80, minWidth: 80, maxWidth: 80 },
    { field: 'createdAt' },
    {
      field: '',
      sortable: false,
      resizable: false,
      width: 100,
      maxWidth: 100,
      cellRenderer: BtnCellRendererComponent,
      cellRendererParams: {
        clicked: (data: any) => {
          console.log(data);
          this.getAllPropertiesFile(data.id, data.name);
        },
        icon: 'download',
      },
    },
    {
      field: '',
      sortable: false,
      resizable: false,
      width: 100,
      maxWidth: 100,
      cellRenderer: BtnCellRendererComponent,
      cellRendererParams: {
        clicked: (data: any) => {
          this.refreshAccessToken(data.id);
        },
        icon: 'refresh',
      },
    }
  ];

  // DefaultColDef sets props common to all Columns
  public defaultColDef: ColDef = {
    resizable: true,
    sortable: false,
    filter: false,
  };

  public rowData$!: Observable<any[]>;

  constructor(
    private customerService: CustomerService,
    private hubspotService: HubspotService,
    private matDialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  onGridReady(params: GridReadyEvent) {
    this.customerService.getCustomers().subscribe((res: any) => {
      console.log(res);
      params.api.setRowData(res);
      this.agGrid.api.sizeColumnsToFit();
      // this.rowData$ = res;
    });
  }

  onCellEditingStopped(event: any) {
    this.customerService.updateCustomer(event.data.id, event.data).subscribe((res: any) => {
      console.log(res);
    });
  }

  openCustomerDialog() {
    this.matDialog.open(CustomerDialogComponent, {
      width: '600px',
    });
  }

  getAllPropertiesFile(hubspotCustomerId: number, customerName: string) {
    this.customerService.getAllPropertiesAsFile(hubspotCustomerId).subscribe((res: any) => {
      this.downloadFile(res, customerName);
    });
  }

  refreshAccessToken(customerId: string) {
    this.hubspotService.refreshAccessToken(customerId).subscribe(() => {

    });
  }

  downloadFile(data: any, customerName: string) {
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = customerName + '-properties.xlsx';
    // const url= window.URL.createObjectURL(blob);
    // window.open(url);
    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

}
